import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
export var SvgElement = styled.svg.withConfig({
  displayName: "ui-kit-SvgElement",
  componentId: "ui-kit-1ai7odw"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 24px;\n  fill: currentColor;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n  color: ", ";\n\n  &.colorSecondary {\n    color: ", ";\n  }\n  &.colorMain {\n    color: ", ";\n  }\n  &.colorDisabled {\n    color: ", ";\n  }\n  &.colorInherit {\n    color: inherit;\n  }\n\n  &.sizeMobile {\n    width: 28px;\n    height: 28px;\n  }\n"], ["\n  display: inline-block;\n  font-size: 24px;\n  fill: currentColor;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n  color: ", ";\n\n  &.colorSecondary {\n    color: ", ";\n  }\n  &.colorMain {\n    color: ", ";\n  }\n  &.colorDisabled {\n    color: ", ";\n  }\n  &.colorInherit {\n    color: inherit;\n  }\n\n  &.sizeMobile {\n    width: 28px;\n    height: 28px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});

var mapColor = function mapColor(color) {
  return "color".concat(capitalize(color));
};

var mapSize = function mapSize(size) {
  return "size".concat(capitalize(size));
};

var SvgIcon = React.forwardRef(function (_a, ref) {
  var _b = _a.width,
      width = _b === void 0 ? 24 : _b,
      _c = _a.height,
      height = _c === void 0 ? 24 : _c,
      _d = _a.viewBox,
      viewBox = _d === void 0 ? "0 0 ".concat(width, " ").concat(height) : _d,
      className = _a.className,
      color = _a.color,
      size = _a.size,
      props = __rest(_a, ["width", "height", "viewBox", "className", "color", "size"]);

  return _jsx(SvgElement, __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    className: classnames(className, color && mapColor(color), size && mapSize(size)),
    ref: ref
  }, props));
});
export default SvgIcon;
var templateObject_1;